import React from 'react'
import styles from '../Footer/Footer.module.scss'

const Footer = () => {
    return (
    <footer className={styles.footer}>
        <div className={styles.footerText}>
            <p>
                {new Date().getFullYear()} © Салон краси Нія в Зінькові
            </p>
        </div>
    </footer>
    )
}

export default Footer
